import { useCallback } from 'react';
import { useCompany } from '../contexts/CompanyContext';
import {
  formatDate as _formatDate,
  formatDateTime as _formatDateTime,
  formatRelativeTime as _formatRelativeTime,
  formatDateShort as _formatDateShort,
  formatDateOnly as _formatDateOnly,
  formatTime as _formatTime,
} from '../utils/dateUtils';

/**
 * Convenience hook returning date formatting functions pre-bound
 * with the company timezone and user's chosen date format.
 */
export function useDateFormat() {
  const { timezone, dateFormat } = useCompany();

  const formatDate = useCallback(
    (dateInput) => _formatDate(dateInput, dateFormat, timezone),
    [dateFormat, timezone]
  );

  const formatDateTime = useCallback(
    (dateInput) => _formatDateTime(dateInput, dateFormat, timezone),
    [dateFormat, timezone]
  );

  const formatRelativeTime = useCallback(
    (dateInput, labels) => _formatRelativeTime(dateInput, dateFormat, timezone, labels),
    [dateFormat, timezone]
  );

  const formatDateShort = useCallback(
    (dateInput) => _formatDateShort(dateInput, timezone),
    [timezone]
  );

  const formatTime = useCallback(
    (dateInput) => _formatTime(dateInput, timezone),
    [timezone]
  );

  // For backend java.time.LocalDate values: stays on the calendar date, no timezone shift.
  const formatDateOnly = useCallback(
    (dateInput) => _formatDateOnly(dateInput, dateFormat),
    [dateFormat]
  );

  return {
    formatDate,
    formatDateTime,
    formatRelativeTime,
    formatDateShort,
    formatTime,
    formatDateOnly,
  };
}
